import { p as proxyCustomElement, H, c as createEvent, h, d as Host } from './p-bfa0dc67.js';
import { c as classNames } from './p-df8c8ec2.js';

const biModalCss = ".sr-only{position:absolute;height:1px;width:1px;padding:0;margin:-1px;overflow:hidden;border:0;left:-9999px;text-indent:-5000px;clip:rect(1px, 1px, 1px, 1px);}*,*:before,*:after{box-sizing:border-box}html,body,div,span,object,iframe,figure,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,code,em,img,small,strike,strong,sub,sup,tt,b,u,i,ol,ul,li,fieldset,form,label,table,caption,tbody,tfoot,thead,tr,th,td,main,canvas,embed,footer,header,nav,section,button,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;text-size-adjust:none}footer,header,nav,section,main{display:block}body{line-height:1.5}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:\"\";content:none}table{border-collapse:collapse;border-spacing:0}input{-webkit-appearance:none;appearance:none;border-radius:0}:host(:focus){outline:none !important;border:none !important}:host{width:100%}:host dialog{border:none;overflow-y:auto}.modaloverlay{position:fixed;top:0;left:0;width:100%;height:100vh;z-index:999;display:none}.modaloverlay.blur{background-color:var(--actions-tint-20, rgba(1, 65, 127, 0.25));backdrop-filter:blur(2px);filter:blur(2px)}.modaloverlay.headerTop80{top:var(--bi-layout-navbar-height)}.modaloverlay.headerTop60{top:60px}div#modaloverlayshow{display:block}dialog{position:fixed;background:white;box-shadow:0px 4px 4px 0px rgba(0, 0, 0, 0.25);z-index:9999;scrollbar-width:thin;scrollbar-color:transparent transparent;flex-direction:column;align-items:center;gap:32px;border-radius:4px;max-height:calc(100vh - 120px);max-width:100%;right:auto;left:auto;margin:auto;justify-content:center;top:0}dialog.dark{background-color:#002341;color:white}dialog.headerTop80{top:var(--bi-layout-navbar-height)}dialog.headerTop60{top:60px}dialog.centerTop{top:50%;transform:translateY(-50%)}dialog.show{display:flex;width:fit-content}dialog.show.fullScreen{width:100%}dialog.right{right:0}dialog.slideIn.right{display:flex;right:0;transition:transform 200ms linear;transform:translateX(100%)}dialog.slideIn.right.show{transform:translateX(0)}dialog.slideIn.left{display:flex;left:0;transition:transform 200ms linear;transform:translateX(-100%)}dialog.slideIn.left.show{transform:translateX(0)}.modal-content.show{overflow-y:scroll;overflow-x:scroll;max-width:100%;display:flex;text-align:start}@media (max-width: 768px){:host{width:100%}dialog ::not(.center){max-width:100%;width:100%;position:unset;right:unset;left:unset}}@media (max-width: 450px){dialog{max-height:100%;max-width:100%;width:100%;right:unset;left:unset}dialog.slideInButtonMobile{top:100%;transition:transform 200ms linear;transform:translateY(100%) !important}dialog.slideInButtonMobile.show{width:100%;transform:translateY(0) !important}dialog.headerTop60.slideInButtonMobile.show,dialog.headerTop80.slideInButtonMobile.show{top:0px;display:block;height:100%}}@media (max-width: 70em){dialog{max-height:100%}dialog.headerTop.slideInButtonMobile.show{top:0px;display:block}}";
const BiModalStyle0 = biModalCss;

const BiModal$1 = /*@__PURE__*/ proxyCustomElement(class BiModal extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.toggleOpen = createEvent(this, "toggleOpen", 7);
        this.closeModal = createEvent(this, "closeModal", 7);
        this.header = null;
        this.slideIn = false;
        this.top = 'center';
        this.alignment = 'center';
        this.slideInButtonMobile = false;
        this.fullScreen = false;
        this.dark = false;
        // eslint-disable-next-line @stencil-community/ban-default-true
        this.blurOverlay = true;
        this.modalOpen = false;
        this.handleEscPressed = (event) => {
            if (event.key === 'Escape' && this.modalOpen) {
                this.toggleModalOpen();
            }
        };
        this.handleHeaderClicked = (event) => {
            const target = event.target;
            // check if  the target isnt the icon
            if (target.tagName === 'BI-NAVBAR' || target.tagName === 'NAV') {
                if (this.modalOpen) {
                    this.toggleModalOpen();
                }
            }
        };
        this.handleOutsideClick = (event) => {
            const dialog = document.querySelector(`${this.modalId}`);
            if (dialog && dialog.contains(event.target)) ;
            else {
                // Clicked outside the modal
                this.toggleModalOpen();
            }
        };
    }
    async closeModalOpen() {
        this.modalOpen = false;
    }
    async toggleModalOpen() {
        this.modalOpen = !this.modalOpen;
        // Toggle the modal-open class on the body element
        document.body.classList.toggle('modal-open');
        //close other modals
        if (this.modalOpen) {
            const openModals = Array.from(document.querySelectorAll('bi-modal'));
            openModals.forEach((modal) => {
                if (modal.id !== this.modalId) {
                    const event = new CustomEvent('closeModal');
                    modal.dispatchEvent(event);
                }
            });
        }
        //disable tabindex when modal is open
        const dialog = document.getElementById(`${this.modalId}`);
        const elementsToDisableTabIndex = Array.from(document.querySelectorAll('body *'))
            .filter((element) => !dialog.contains(element))
            .filter((element) => (this.header ? !this.header.contains(element) : true));
        if (this.modalOpen) {
            elementsToDisableTabIndex.forEach((element) => {
                element.setAttribute('tabindex', '-1');
            });
        }
        else {
            elementsToDisableTabIndex.forEach((element) => {
                const originalTabindex = element.getAttribute('data-tabindex');
                if (originalTabindex) {
                    element.setAttribute('tabindex', originalTabindex);
                }
                else {
                    element.removeAttribute('tabindex');
                }
            });
        }
    }
    componentDidLoad() {
        const header = document.querySelector('bi-navbar') || document.querySelector('header');
        this.header = header;
        if (this.header && (this.top === '80' || this.top === '60')) {
            this.header.addEventListener('click', this.handleHeaderClicked);
        }
        document.addEventListener('keydown', this.handleEscPressed);
    }
    disconnectedCallback() {
        if (this.top === '80' || this.top === '60') {
            this.header?.removeEventListener('click', this.handleHeaderClicked);
        }
        document.removeEventListener('keydown', this.handleEscPressed);
    }
    render() {
        return (h(Host, { key: '15274197bc2055d543848daf678c7a5798a7e02c', id: this.modalId }, h("dialog", { key: 'fcf702f077763d91889d7e52b234bad6575c32be', class: classNames('dialog', { show: this.modalOpen ? 'show' : '' }, { slideIn: this.slideIn }, this.alignment, { headerTop60: this.top === '60' ? 'headerTop60' : '' }, { headerTop80: this.top === '80' ? 'headerTop80' : '' }, { centerTop: this.top === 'center' ? 'centerTop' : '' }, { slideInButtonMobile: this.slideInButtonMobile }, { fullScreen: this.fullScreen }, { dark: this.dark }), id: `dialog${this.modalId}` }, this.modalOpen && (h("div", { key: '2cea8804880d90237931036c206481f58ae32d78', class: classNames('modal-content', { show: this.modalOpen ? 'show' : '' }), id: `content${this.modalId}` }, h("slot", { key: 'd99faa0f4c1485fd78fd6ba7b8d5210aad3e8670' })))), h("div", { key: '63d9bbc33da77434b36efc7da32c6a3117b251c5', class: classNames('modaloverlay', { show: this.modalOpen ? 'show' : '' }, { headerTop80: this.top === '80' ? 'headerTop80' : '' }, { headerTop60: this.top === '60' ? 'headerTop60' : '' }, { blur: this.blurOverlay }), id: `modaloverlay${this.modalOpen ? 'show' : ''}`, onClick: this.handleOutsideClick }, ' ')));
    }
    static get style() { return BiModalStyle0; }
}, [1, "bi-modal", {
        "modalId": [1, "modal-id"],
        "slideIn": [4, "slide-in"],
        "top": [1],
        "alignment": [1],
        "slideInButtonMobile": [4, "slide-in-button-mobile"],
        "fullScreen": [4, "full-screen"],
        "dark": [4],
        "blurOverlay": [4, "blur-overlay"],
        "modalOpen": [32],
        "closeModalOpen": [64],
        "toggleModalOpen": [64]
    }, [[0, "closeModal", "closeModalOpen"], [0, "toggleOpen", "toggleModalOpen"]]]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-modal"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-modal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiModal$1);
            }
            break;
    } });
}

const BiModal = BiModal$1;
const defineCustomElement = defineCustomElement$1;

export { BiModal, defineCustomElement };
